document.addEventListener('DOMContentLoaded', function () {
  var faqs = document.querySelectorAll('.clearrear-premium .cr-faq-question');
  faqs.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.cr-faq-item');
      if (!item) return;
      var wrap = item.parentElement;
      if (wrap) {
        wrap.querySelectorAll('.cr-faq-item.is-open').forEach(function (openItem) {
          if (openItem !== item) openItem.classList.remove('is-open');
        });
      }
      item.classList.toggle('is-open');
    });
  });

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('.clearrear-premium .cr-fade-up').forEach(function (el) {
    observer.observe(el);
  });
});
